import { Box, Button, Text, View } from "native-base";
import React, { useCallback, useEffect, useState, useTransition } from "react";
import {  scaleAll_, scaleFont_, verticalScale_ } from "../../../Universal/API/Scale";
import { PorfolioList } from "../../../Universal/API/Context-API/AppProvider";
import FastImage from "@d11/react-native-fast-image";
import { Platform, StyleSheet, TouchableOpacity } from "react-native";
import { useAppContext } from "../../../Universal/API/Context-API/AppContext";
// import CollectionsSmall from "../../../Navigator/TopNavigator/TopSlideOut/Components/CollectionsSmall/CollectionsSmall";

import Carousel, {ICarouselInstance, Pagination} from "react-native-reanimated-carousel";
import { runOnJS, useSharedValue } from "react-native-reanimated";
import { PressableWrap } from "../../../Universal/Buttons/PressableColorWrap/PressableColorWrap";
import SimpleCenteredSpinner from "../../../Universal/SimpleCenteredSpinner/SimpleCenteredSpinner";
import { parseDescriptionToTextElements } from "../Expanded/ExpandedPortfolio";
import { Gesture, GestureDetector } from "react-native-gesture-handler";


export interface position {
    x: number,
    y: number,
    height: number,
    width: number

}
export interface PortfolioBadge {
    portfolio: PorfolioList
    onPress?: ({portfolio}: {portfolio:PorfolioList, position: position}) => any
}
const PortfolioBadge:React.FC<PortfolioBadge> = ({portfolio, onPress}) => {

    const {isSmallVersion, currentWidth} = useAppContext()
    useEffect(() => {
        console.log( portfolio.images[0])
    }, [])

    const ref = React.useRef<ICarouselInstance>(null);
	const progress = useSharedValue<number>(0);

    const onPressPagination = (index: number) => {
		ref.current?.scrollTo({
			/**
			 * Calculate the difference between the current index and the target index
			 * to ensure that the carousel scrolls to the nearest index
			 */
			count: index - progress.value,
			animated: true,
		});
	};
 
    const [shadow, setShadow] = useState(false)

    const [shadowButton, setShadowButton] = useState(false)

    const [isLoading, setLoading] = useState(false)


    const [containerWidth, setContainerWidth] = useState(0);

     const handleMouseMove = (event: React.MouseEvent<HTMLDivElement>) => {
            if (!containerWidth) return;
    
            const mouseX = event.clientX - event.currentTarget.getBoundingClientRect().left;
            const totalSlides = portfolio.images.length;
            const newIndex = Math.floor((mouseX / containerWidth) * totalSlides);
    
            ref.current?.scrollTo({
                index: newIndex,
                animated: true
            });
    };

    const [position, setPosition] = useState<position | null>(null)

    const PRESS = () => {
        setLoading(true)
            try{
                if(onPress)
                 onPress({
                        portfolio: portfolio,
                        position: position
                    })
                   
            }catch(e){

            }
            setTimeout(() => {
                setLoading(false)
            }, 400)
            
            
    }

    const currentIndex = useSharedValue(0); // new shared state
    const [autoplay, setAutoplay] = useState(true);

    // Wrap your carousel width for swipe ratio calc
const carouselWidth = isSmallVersion ? (currentWidth - 40) : scaleAll_(300);
const isSwiping = useSharedValue(false);
const swipeGesture = Gesture.Pan()
.activeOffsetX([-10, 10]) // Only trigger horizontal gestures
.failOffsetY([-4, 4])     // ⛔ Fail immediately if user moves vertically
  .onBegin(() => {
    isSwiping.value = true;
    runOnJS(setAutoplay)(false); // stop autoplay while swiping
  })
  .onEnd((event) => {
    const threshold = 20; // minimum swipe in px
    const offset = event.translationX;

    if (offset > threshold) {
      // swipe right → previous
      const newIndex = Math.max(0, currentIndex.value - 1);
      ref.current?.scrollTo({ index: newIndex, animated: true });
      currentIndex.value = newIndex;
    } else if (offset < -threshold) {
      // swipe left → next
      const newIndex = Math.min(portfolio.images.length - 1, currentIndex.value + 1);
      ref.current?.scrollTo({ index: newIndex, animated: true });
      currentIndex.value = newIndex;
    }

    isSwiping.value = false;
    runOnJS(setAutoplay)(true); // resume autoplay
  })
  
  .activeOffsetX([-10, 10])
  .failOffsetY([-5, 5])
    return (
        <PressableWrap 
       
        onPress = {PRESS}
            colors={
                {
                    onHoverIn: undefined,
                    onHoverOut: undefined
                }
            }
            onHoverIn={() => {
                setShadow(true)
            }}
            onHoverOut={() => {
                setShadow(false)
            }}
        >
            <Box 
             onLayout = {(event) => {
                setPosition({
                    x: event.nativeEvent.layout.x,
                    y: event.nativeEvent.layout.y,
                    height: event.nativeEvent.layout.height,
                    width: event.nativeEvent.layout.width
                })
            }}
            minHeight={isSmallVersion ? verticalScale_(290) :verticalScale_(320)} 
            maxWidth={isSmallVersion ? ((currentWidth -40) ) : scaleAll_(300)}
            background={'gray.100'} borderTopRadius={10}
            // borderWidth={0.3}
            // style={{borderWidth:0.1}}
            overflow={'hidden'} borderBottomRadius={10} 
            
            shadow={(shadow || shadowButton) ? '4' : 'none'}
            style={{
            }}
            >
            {/* <Box backgroundColor={'white'} overflow={'hidden'} 
            height={isSmallVersion ? ((currentWidth - 20) ) : scaleAll_(150)}
            width={isSmallVersion ? ((currentWidth -20) ) : scaleAll_(300)}
            borderWidth={1} borderColor={'rgba(0,0,0,0.5)'}>
            
            

            
            </Box> */}
            <Box 
            ref={(el) => {
                if (el) setContainerWidth(el.getBoundingClientRect().width);
            }}
            // onMouseMove={handleMouseMove}
            style={{
            }}
            >
                <GestureDetector gesture={swipeGesture} touchAction="pan-y">

            <Carousel 
                
                    ref={ref}
                    height={isSmallVersion ? ((160 - 20) ) : scaleAll_(150)}
                    width={isSmallVersion ? ((currentWidth -40) ) : scaleAll_(300)}
                    data = {portfolio.images}
                    panGestureHandlerProps={{
                        activeOffsetX: [-10, 10],
                    }}
                    renderItem={
                        ({item}) => {
                        return (
                        <FastImage
                                source={{
                                    uri: item
                                }}
                                style = {[StyleSheet.absoluteFill, {
                                    
                                }]}
                                resizeMode='cover'
                            />)
                        
                        }
                    }
                    onProgressChange={progress}
                    pagingEnabled={true}
                    autoPlay={autoplay}
                    autoPlayInterval={10000}
                    // panGestureHandlerProps={{
                    //     activeOffsetX: [-10, 10], // Only capture gestures primarily horizontal
                    //     failOffsetY: [-5, 5],     // Allow vertical scrolls to pass through
                    // }}
                    enabled={false}
                    
                      
                
                />
                </GestureDetector>
                <Pagination.Basic size={5} 
                                        data={portfolio.images}	
                                        dotStyle={{ backgroundColor: "rgba(0,0,0,0.4)", borderRadius: 10, transform: [{scale: 0.9}]  }}
                                        activeDotStyle={{ backgroundColor: "#f1f1f1", transform: [{scale: 1.1}] }}
                                        containerStyle={{ gap: 5, zIndex: 10000, position: 'absolute', bottom: 10}}			
                                            progress={progress}
                                    />
            </Box>
            <Box paddingLeft={3}>
            <Text style = {{
                        color: 'black',
                        fontSize: scaleFont_(16),
                        lineHeight: scaleFont_(28),
                        verticalAlign: 'bottom',
                        textAlign: 'left',
                        fontWeight: '500'


                        // fontFamily: webFont('Papyrus')
                        }} selectable={false}>{portfolio.name}</Text>
            <Box paddingRight={3}>
            <Text style = {{
                color: 'rgba(0,0,0,0.75)',
                fontSize: scaleFont_(14),
                lineHeight: scaleFont_(18),
                verticalAlign: 'bottom',
                textAlign: 'left',
                flexWrap: 'wrap',
            
            }}>
                {parseDescriptionToTextElements(portfolio.description_small)}
            </Text>
            </Box>
            </Box>
            <Box style = {{flexDirection: 'column-reverse', flex: 1, marginHorizontal: 20, paddingTop: 20, marginBottom: 20}}> 
            <Button 
            onPress = {PRESS}
            borderRadius={10}
            spinnerPlacement='start'
            // spinner={}
            // isLoading={true}
            backgroundColor={
                shadowButton ? 'blue.300' :
                'blue.400'} onHoverIn={() => {
                setShadowButton(true)
            }} onHoverOut={() => setShadowButton(false)}>
                <Text color={`rgba(255,255,255,${isLoading ? 0: 1})`}>Подробнее...</Text>
                {isLoading &&<SimpleCenteredSpinner height={20} width={20}/>}
            </Button>
            </Box>
            </Box>
        </PressableWrap>
    )
}

export default React.memo(PortfolioBadge);